<template>
    <div class="in-con in-inOne">
        <div class="inOne-info">
            <h2 style="font-size:24px;">看诊信息</h2>
        </div>
        <div class="inOne-treatment">
            <h2>看诊时间：<span format='yyyy-MM-dd'>{{this.timeDate.periodOfTime}}</span></h2>
            <h2>看诊医生：<span>{{this.timeDate.doctorName}}</span></h2>
            <div style="text-align: right">
                <el-switch
                        v-model="priceSwitchVal"
                        active-text="显示药价"
                        inactive-text="隐藏药价">
                </el-switch>
            </div>
        </div>
        <el-tabs class="inOne-TabCon" v-model="activeName" @tab-click="handleClick" type="border-card">
            <el-tab-pane label="病历" name="first">
                <inRecords ref="c2"></inRecords> 
            </el-tab-pane>
            <el-tab-pane label="中药汤方" name="second">
                <inAdvices :priceSwitchVal="priceSwitchVal" ref="c3"></inAdvices>
            </el-tab-pane>
            <el-tab-pane label="处置方法" name="examine">
                <inExamine ref="c4"></inExamine>
            </el-tab-pane> 
            <el-tab-pane label="本次测量值" name="third"> 
                <inChecks ref="c5"></inChecks>
            </el-tab-pane> 
        </el-tabs> 
    </div>
</template>

<script>
  import Records from './inquiryRecords'
  import Advices from './inquiryAdvices'
  import Checks from './inquiryChecks'
  import Examine from './inquiryExamine'

  export default {
    data() {
      return {
        radio: '1',
        activeName: 'first',
        priceSwitchVal:false
      }
    },
    props: ['timeDate'],
    components: {
      inRecords: Records,
      inAdvices: Advices,
      inChecks: Checks,
      inExamine: Examine
    },
    methods: {
      handleClick(tab, event) {
      },
      getData(o){
        this.$refs.c2.getData(o);
        this.$refs.c3.getData(o);
        this.$refs.c4.getData(o);
        this.$refs.c5.getData(o);
      }
    }
  }
</script>

<style type="text/css" scoped>
    .in-inOne {
        text-align: left;
    }
    .inOne-info {
        line-height: 40px;
        margin-bottom: 10px;
        text-align: center;
    }

    .inOne-info h2 {
        color: black;
        font-size: 20px;
        margin-left: 20px;
    }

    .in-order {
        float: right;
        margin-right: 30px !important;
    }

    .in-order i {
        margin-right: 8px;
    }

    .inOne-treatment {
        padding: 20px 20px 20px 0;
        border-top: 1px solid #dcdcdc;
    }

    .inOne-treatment h2 {
        display: block!important;
        font-size: 18px;
        margin-left: 20px;
        color: #282828;
    }

    .inOne-treatment h2 span {
        color: #282828;
    }

    .inOne-drug p {
        margin: 0 0 0 8px;
        width: 80%;
        display: inline-block;
        white-space: pre-wrap;
        color: #646a6b;
    }

    .inOne-TabSwitch {
        border-top: 1px solid #dcdcdc;
        padding-bottom: 10px;
    }

    .inOne-TabSwitch ul {
        list-style: none;
        margin: 0;
        padding: 10px 0px 0 30px;
        overflow: hidden;
        width: 95%;
    }

    .inOne-table, .inOne-addData {
        margin-top: 20px;
    }

    .inOne-TabCon {
        border-bottom-right-radius: 10px;
        border-bottom-left-radius: 10px;
    }
</style>



// WEBPACK FOOTER //
// inquiryOne.vue?4c7b7413